const list = {
  // =================================================================================================================
  components() {
    return [
      {
        component: "search-year",
        label: "대상년도",
        value: "year",
        query: { y: "year" },
        options: {
          default: new Date().getFullYear(),
        },
      },
      {
        component: "search-select-field",
        label: "사업장",
        value: "field",
        query: { f_id: "fieldId", f_name: "fieldName" },
        options: {
          default: { fieldId: "", fieldName: "" },
        },
      },
      {
        component: "search-column-keyword",
        label: "검색조건",
        value: "column",
        query: { ck_t: "head", ck_k: "keyword" },
        options: { hiddenList: ["사업장명", "대상년도", "교육훈련평가 결과서"] },
      },
    ];
  },
  getConditions: (nav) => {
    const conditions = [];
    const search = nav.value;

    // 검색연도
    let year = search.year;
    if (!year) year = new Date().getFullYear();
    conditions.push({ key: "header.year", operator: "=", value: `${year}` });

    // 사업장
    if (search.field) {
      conditions.push({ key: "body.stdInfo.field_id", operator: "=", value: search.field.fieldId });
    }

    //  검색조건
    const heads = list.getHead().map((e) => {
      return { [e.name]: e.key };
    });
    // 배열의 객체들을 하나의 객체로 합치기
    const types = Object.assign({}, ...heads);
    if (search.column && search.column.keyword) {
      conditions.push({ key: types[search.column.head], operator: "LIKE", value: `%${search.column.keyword}%` });
    }
    return conditions;
  },

  // =================================================================================================================
  getHead: () => {
    return [
      {
        name: "대상년도",
        key: "header.year",
      },
      {
        name: "사업장명",
        key: "body.stdInfo.field_name",
      },
      {
        name: "업체명",
        key: "body.companyName",
      },
      {
        name: "수급업무",
        key: "body.수급업무",
      },
      {
        name: "인원수",
        key: "body.인원수",
      },
      {
        name: "안전예방지수(30)",
        key: "body.총안전예방지수",
      },
      {
        name: "재해지수(40)",
        key: "body.총재해지수",
      },
      {
        name: "안전경영지수(30)",
        key: "body.총안전경영지수",
      },
      {
        name: "가감점",
        key: "body.총가감점",
      },
      {
        name: "총점(100)",
        key: "body.총평가점수",
      },
      {
        name: "비고",
        key: "body.비고",
        style: { minWidth: "200px" },
      },
    ];
  },
  getCol: (index, value, func) => {
    try {
      const postContent = JSON.parse(value.post_content);
      switch (index) {
        case 0:
          return postContent.header.year || "-"; // 대상년도
        case 1:
          return func.getContent(value).stdInfo.field_name || "-"; // 사업장명
        case 2:
          return func.getContent(value).companyName || "-"; // 업체명
        case 3:
          return func.getContent(value).수급업무 || "-"; // 수급업무
        case 4:
          return func.getContent(value).인원수 || "0"; // 인원수
        case 5:
          return func.getContent(value).총안전예방지수 || "0"; // 안전예방지수
        case 6:
          return func.getContent(value).총재해지수 || "0"; // 재해지수
        case 7:
          return func.getContent(value).총안전경영지수 || "0"; // 안전경영지수
        case 8:
          return func.getContent(value).총가감점 || "0"; // 가감점
        case 9:
          return func.getContent(value).총평가점수 || "0"; // 총점
        case 10: {
          // 비고
          const point = func.getContent(value).총평가점수;
          return {
            type: "html",
            html:
              point >= 70
                ? `<span style="background-color: #28c76f; border-radius: 5px; color: white; padding: 2px 7px;">적합</span>`
                : `<span style="background-color: #EA5455; border-radius: 5px; color: white; padding: 2px 7px;">안전환경위원회 심의 필요</span>`,
          };
        }
      }
    } catch (e) {
      /*ignore*/
    }
    return "";
  },
  getSearchKeyValue: (nav) => {},
  getSearchKeyword: (nav) => {},
};
export default list;
